/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_OffersInputs */

const en_directory_hubs_signals_offers = /** @type {(inputs: Directory_Hubs_Signals_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community offers`)
};

const zh_directory_hubs_signals_offers = /** @type {(inputs: Directory_Hubs_Signals_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社区优惠`)
};

/**
* | output |
* | --- |
* | "Community offers" |
*
* @param {Directory_Hubs_Signals_OffersInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_offers = /** @type {((inputs?: Directory_Hubs_Signals_OffersInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_OffersInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_offers(inputs)
	return zh_directory_hubs_signals_offers(inputs)
});
export { directory_hubs_signals_offers as "directory.hubs.signals.offers" }